<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M28.71 15.29l-2-2L17.41 4a2 2 0 00-2.82 0l-9.3 9.29-2 2a1 1 0 001.42 1.42l.29-.3V27a2 2 0 002 2h18a2 2 0 002-2V16.41l.29.3a1 1 0 001.42 0 1 1 0 000-1.42zM25 27H7V14.41l9-9 9 9z"/><path d="M12 15a4 4 0 104-4 4 4 0 00-4 4zm7 0a3 3 0 11-3-3 3 3 0 013 3z"/><path d="M18.9 19.07a6.16 6.16 0 01-5.81 0 1 1 0 00-.72-.09l-2.13.55a1 1 0 00-.74 1v4.09a.5.5 0 00.5.5.5.5 0 00.5-.5V20.5l2.11-.5a7.16 7.16 0 006.76 0l2.13.56v4.09a.5.5 0 00.5.5.5.5 0 00.5-.5V20.5a1 1 0 00-.75-1l-2.13-.5a1 1 0 00-.72.07z"/></svg>